<template>
  <div>
    <div class="mb-5">
      <div>
        <zip-upload @input="uploadActOriginal" />
      </div>

      <div v-if="transaction.act_original">
        <a
          class="btn btn-info mw mb-2"
          target="_blank"
          :href="transaction.act_original"
          >{{ "show_file" | setText("Посмотреть файл") }}</a
        >
      </div>

      <button @click="getPdf" class="btn btn-info mw">
        {{ "get_pdf" | setText("Получить договор") }}
      </button>
    </div>

    <div v-if="transaction.act_original">
      <div>
        <client-info
          :changeItem="true"
          :disablePinfl="true"
          :id="order['client']['id']"
        />

        <div>
          <zip-upload v-model="act" />
          <div v-if="transaction.act">
            <a
              class="btn btn-info mw mb-2"
              target="_blank"
              :href="transaction.act"
              >{{ "show_file" | setText("Посмотреть файл") }}</a
            >
          </div>
        </div>
      </div>
      <div class="install-control">
        <button @click="save" class="btn btn-success">
          {{ "next_step" | setText("Далее") }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../plugins/functions";
import ClientInfo from "@/components/Partners/ClientInfo";
export default {
  components: {
    ClientInfo,
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  name: "filter",
  async created() {},
  methods: {
    uploadActOriginal(val) {
      this.createTransaction({
        act_original: val,
      });
    },

    getPdf() {
      this.$loading(true);
      this.$http({
        url: `${this.partner["endpoint_url"]}contract/pdf`,
        method: "GET",
        headers: {
          Authorization: `${
            this.partner["type_auth"] ? this.partner["type_auth"] + " " : ""
          }${this.partner["api_secret_key"]}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        params: {
          app_id: `${
            this.transaction.exchange_id
              ? this.transaction.exchange_id
              : this.value.data.app_id
          }`,
        },
      })
        .then((response) => {
          if (response.data) {
            // this.createTransaction({ act_original: "https://test.dd" });
          }
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
          }, 500);
        });
    },

    async createFile(client = null, name = "passport_1") {
      try {
        let response = await fetch(client[name]);
        let data = await response.blob();
        let metadata = {
          type: "image/jpeg",
        };
        const file = new File([data], `${client["id"]}_${name}.jpg`, metadata);
        return file;
      } catch (error) {}
      return "";
    },

    async save() {
      this.$loading(true);
      let bodyFormData = new FormData();

      bodyFormData.append(
        "passport_front",
        await this.createFile(this.order.client, "passport_1")
      );
      bodyFormData.append(
        "passport_back",
        await this.createFile(this.order.client, "passport_3")
      );
      bodyFormData.append("signed_contract", this.act);
      bodyFormData.append(
        "passport_selfie",
        await this.createFile(this.order.client, "passport_4")
      );

      bodyFormData.append(
        "app_id",
        this.transaction.exchange_id
          ? this.transaction.exchange_id
          : this.value.data.app_id
      );

      this.$http({
        url: `${this.partner["endpoint_url"]}contract/upload/photo`,
        method: "POST",
        data: bodyFormData,
        headers: {
          Authorization: `Bearer ${this.partner["api_secret_key"]}`,
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          if (response.data) {
            this.createTransaction({
              act: this.act,
              step: "contract-sign",
            });
            this.$emit("setStep", "contract-sign");
          }
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.createTransaction({
            akt: this.act,
          }); //test

          // this.$emit("setStep", "contract-sign"); //test

          this.$loading(false);
        });
    },
  },
  data() {
    return {
      act: null,
    };
  },
};
</script>

